import FAQ, { type IQuestion } from "@core-components/faq/FAQ";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import type React from "react";

const LoLFAQ: React.FC = () => {
  const { t } = useAppTranslation("components.faq");
  const lolQuestions = t("lol_questions", {
    returnObjects: true,
  }) as IQuestion[];

  return <FAQ TextGradient={SSLoLGradientText} questions={lolQuestions} />;
};

export default LoLFAQ;
